import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'campaigns/campaign'
const model = 'campaigns/campaign'
const wizardName = 'Employment association';
const wizardObject = 'OperatorEmployment';
const wizardAction = 'operatorAssociation';

const OperatorAssociation = (params) => {
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);
    const { actives } = useDrawer();

    const { doAction, item, loadOne, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);

    const detailConfig = {
        "tabs": [
            {
                "name": "association",
                "fieldsets": [
                    {
                        "name": "association",
                        "fields": {
                            "available_employments": {
                                "type": "sectiontitle",
                                "className": "col-12"
                            },
                            "associated": {
                                "type": "employmentlist",
                                "defaultSelectedValues": [],
                                "enableSelection": true,
                                "disableMultipleRowSelection": true,
                                "dataProviderName": "persons/employment",
                                "className": "col-12",
                                "required": "true",
                                "hideTableToolbar": "true"
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    const [editing, setEditing] = useState(false)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    // svuoto la selezione del drawer padre per evitare riassegnazioni
                    params.setSelected && params.setSelected([]);

                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success])

    const handleSave = async (data) => {
        // data = {...data, selectedElements: params.selected}
        // console.info('SONGHE IE', data, "SELECTED ELEEMENTS", params.selected);
        doAction && doAction({ action: wizardAction, model: dataProviderName, data: data });
    }

    return (
        <>
            <DetailComponent
                values={{
                    selectedElements: params.selected,
                    campaignId: params.campaignId
                }}
                modelName={model.split('/')[1]}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                onEditing={setEditing}
                save={handleSave}
                saving={saving}
                errors={errors}
                editing={true}
                errorMessage={errorMessage}
                title={t(wizardName)}
                canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
                header={
                    <InfoHeader
                        view="wizard"
                        title={t(wizardName)}
                        subtitle={t('Assign the {{count}} Leads to the selected {{wizardObject}}', { wizardObject: wizardObject,count: params?.selected?.length ?? 0})}
                    />
                }
                {...params}
            />
        </>
    )
}

export default OperatorAssociation;